import React, {Component} from 'react';
import ArticleListRow from './ArticleListRow';
import SortableHead from '../common/list/SortableHead';
import * as articleActions from '../../actions/articleActions';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const ArticlesList = ({articles, onDelete, onClone, listId, intl}) => {
    return (
        <div>
            <table className="table table-striped">
                <SortableHead
                    listId={listId}
                    action={articleActions.loadArticles}
                    columns={[
                        {
                            title: '#',
                            name: 'id',
                        },
                        {
                            title: intl.formatMessage(messages.listColumnTitleHeading),
                            name: 'heading',
                        },
                        {title: intl.formatMessage(messages.listColumnTitleCategories)},
                        {
                            title: intl.formatMessage(messages.listColumnTitlePublishedAt),
                            name: 'publishAt',
                        },
                        {
                            title: intl.formatMessage(messages.listColumnTitleOptions),
                            className: 'text-right'
                        },
                    ]}
                />
                <tbody>
                {
                    articles.map(article => <ArticleListRow
                        key={article.id}
                        article={article}
                        onDelete={onDelete}
                        onClone={onClone}
                    />)
                }
                </tbody>
            </table>
        </div>
    );
};

export default injectIntl(ArticlesList);


// WEBPACK FOOTER //
// ./web/src/components/articles/ArticlesList.jsx